module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/medium-self-10x15-150x1200.svg";